import * as React from 'react';
import {
  Box,
  Alert,
  IconButton,
  Collapse,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SxProps, Theme } from '@mui/material/styles'

type InfoBoxProps = {
  children: React.ReactNode,
  closeable?: boolean,
  color?: string
  sx?: SxProps<Theme>,
  icon?: string
}

export default function InfoBoxAlert({ children, closeable = false, color = '#1976d2', sx, icon }: InfoBoxProps) {
  const [open, setOpen] = React.useState(true);

  return (
    <Box sx={{
      width: '100%',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      ...((sx as object) || {}),
    }} >
      <Collapse in={open}>
        <Alert
          action={closeable &&
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
          severity="info"
          iconMapping={{
            info: <calcite-icon
              icon={icon}
              scale='l'
              style={{
                color: color,
                alignSelf: 'center',
              }}></calcite-icon>
            ,
          }}
        >
          {children}
        </Alert>
      </Collapse>
    </Box>
  );
}
